<template>
  <div class="gestion-cumplimientos-container py-4">
    <!-- Cabecera -->
    <div class="gestion-header d-flex justify-content-between align-items-center mb-4 flex-wrap">
      <h2 class="gestion-title d-flex align-items-center mb-2 mb-md-0">
        <font-awesome-icon :icon="['fas', 'scale-balanced']" class="me-2 text-primary" />
        Gestión de Cumplimientos
      </h2>

      <div class="gestion-actions d-flex flex-wrap gap-2">
        <button
          class="btn btn-outline-primary btn-lg"
          :class="{ active: vistaActual === 'listar' }"
          @click="vistaActual = 'listar'"
        >
          <font-awesome-icon :icon="['fas', 'list']" class="me-2" />
          Ver Cumplimientos
        </button>

        <button
          class="btn btn-primary btn-lg"
          :class="{ active: vistaActual === 'alta' }"
          @click="vistaActual = 'alta'"
        >
          <font-awesome-icon :icon="['fas', 'plus']" class="me-2" />
          Nuevo Grupo Cumplimiento
        </button>
      </div>
    </div>

    <!-- Contenido dinámico -->
    <transition name="fade" mode="out-in">
      <component :is="componenteActual" @cumplimientoCreado="crearCumplimiento" @grupoGuardado="agregarGrupo" />
    </transition>
  </div>
</template>

<script>
import ListarCumplimientos from '@/components/Cumplimiento/listar-cumplimientos.vue';
import AltaCumplimiento from '@/components/Cumplimiento/alta-editar-grupo.vue';
import axios from '@/axios';

export default {
  components: {
    ListarCumplimientos,
    AltaCumplimiento,
  },
  data() {
    return {
      vistaActual: 'listar',
      grupos: [],
      clubActual: this.$store.getters.getClubActual,
      mensaje: '',
    };
  },
  computed: {
    componenteActual() {
      return this.vistaActual === 'alta' ? 'AltaCumplimiento' : 'ListarCumplimientos';
    },
  },
  methods: {
    async cargarGrupos() {
      try {
        const response = await axios.get('/api/cumplimiento/grupos', { params: { club_id: this.clubActual.id } });
        this.grupos = response.data;
      } catch (error) {
        console.error('Error al cargar grupos:', error);
      }
    },
    async crearCumplimiento(nuevoCumplimiento) {
      if (!nuevoCumplimiento.grupo_id) {
        alert('Por favor, seleccione un grupo.');
        return;
      }

      try {
        await axios.post('/api/cumplimiento/etiquetas', nuevoCumplimiento);
        this.mensaje = 'Cumplimiento o etiqueta creada exitosamente.';
        this.cargarGrupos(); // Refresh groups after creation
      } catch (error) {
        console.error('Error al crear el cumplimiento:', error);
        this.mensaje = 'Error al crear el cumplimiento.';
      }
    },
    manejarCerrar(nuevoCumplimiento) {
      if (nuevoCumplimiento) {
        this.crearCumplimiento(nuevoCumplimiento);
      }
      this.vistaActual = 'listar';
    },
    async agregarGrupo(nuevoGrupo) {
      this.grupos.push(nuevoGrupo); // Agregar el nuevo grupo a la lista
      this.vistaActual = 'listar'; // Cambiar la vista para mostrar la lista actualizada
    },
  },
  mounted() {
    this.cargarGrupos();
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/custom-bootstrap.scss';

.gestion-cumplimientos-container {
  background-color: $light;
  border-radius: 12px;
  padding: 2.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.gestion-header {
  border-bottom: 2px solid $secondary;
  padding-bottom: 1.5rem;
}

.gestion-title {
  font-size: 1.8rem;
  font-weight: bold;
  color: $dark;
}

.gestion-actions .btn {
  font-size: 1.1rem;
  padding: 0.7rem 1.6rem;
  border-radius: 30px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
}

.btn-outline-primary {
  border-color: $app-primary;
  color: $app-primary;
}

.btn-outline-primary:hover,
.btn-outline-primary.active {
  background-color: $app-primary;
  color: #fff;
}

.btn-primary {
  background-color: $app-primary;
  border: none;
}

.btn-primary:hover,
.btn-primary.active {
  background-color: $app-primary;
  opacity: 0.9;
}

/* Animación suave */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
